import { useRef, useState } from 'react';
import { DateRange as Picker, Range } from 'react-date-range';

import { Colors } from '@sternum/web/components/theme/constants';

import { DateRange } from './DateRangePicker.types';
import { MonthNavigator } from './MonthNavigator';

import { DateRangeWrapper } from './DateRangePicker.styles';

interface DateRangePickerProps {
  initialValue: DateRange;
  onChange: (range: DateRange) => void;
  width?: string | number;
  minDate?: Date;
  maxDate?: Date;
}

export function DateRangePicker({ initialValue, onChange, width, minDate, maxDate }: DateRangePickerProps) {
  const changesCounter = useRef(0);

  const [value, setValue] = useState<Range>({
    ...initialValue,
    key: 'valueKey',
  });

  return (
    <div style={{ width }}>
      <DateRangeWrapper>
        <Picker
          showMonthArrow={false}
          rangeColors={[Colors.BrandBlueTheLightest]}
          showDateDisplay={false}
          showMonthAndYearPickers={false}
          onChange={(item) => {
            setValue(item.valueKey);
            changesCounter.current++;

            const { startDate, endDate } = item.valueKey;

            if (changesCounter.current !== 2 || !startDate || !endDate) return;

            changesCounter.current = 0;

            onChange({ startDate, endDate });
          }}
          moveRangeOnFirstSelection={false}
          ranges={[value]}
          weekStartsOn={6}
          weekdayDisplayFormat="EEEEEE"
          navigatorRenderer={(currentDate, changeShownDate) => {
            return <MonthNavigator shownDate={currentDate} changeShownDate={changeShownDate} />;
          }}
          minDate={minDate}
          maxDate={maxDate}
        />
      </DateRangeWrapper>
    </div>
  );
}
